import { eventChannel } from "redux-saga";
import { parse } from "cookie";
import {
  take,
  takeEvery,
  call,
  put,
  fork,
  cancel,
  cancelled,
  getContext,
} from "redux-saga/effects";
import { CONTEXT } from "@const/redux";
import { localstorageKeys } from "@const/store";
import { SOCKET_DICTIONARY } from "../socketDictionary";
import { startSocketActionType, stopSocketActionType } from "./actionTypes";
import { setSocket } from "@redux/socket/actions";

const COOKIE_NAME = "AWSALB";

let socketTask;

const getOrCreateSocket = async (SocketService, token) => {
  return SocketService.getOrCreateSocket(token);
};

const getAuthToken = (StorageService) => {
  const session = StorageService.get(localstorageKeys.session);
  return session?.accessToken;
};

const createSocketChannel = (socket) => {
  return eventChannel((emit) => {
    socket.io.on("open", () => {
      socket.io.engine.transport.on("pollComplete", () => {
        const request = socket.io.engine.transport.pollXhr.xhr;
        const cookieHeader = request.getResponseHeader("set-cookie");
        if (!cookieHeader) {
          return;
        }
        cookieHeader.forEach((cookieString) => {
          if (cookieString.includes(`${COOKIE_NAME}=`)) {
            const cookie = parse(cookieString);
            socket.io.opts.extraHeaders = {
              cookie: `${COOKIE_NAME}=${cookie[COOKIE_NAME]}`,
            };
          }
        });
      });
    });
    socket.on("connect", (event) => {
      return emit({ type: "ws:connect", payload: event });
    });
    socket.on("close", (event) => emit({ type: "ws:close", payload: event }));

    Object.keys(SOCKET_DICTIONARY).forEach((key) => {
      socket.on(key, (event) => {
        return emit({ type: SOCKET_DICTIONARY[key], payload: event });
      });
    });

    return () => {
      socket?.close();
    };
  });
};

function* watchSocketChannel() {
  const { StorageService, SocketService } = yield getContext(CONTEXT.SERVICES);
  let channel = null;

  try {
    const token = yield call(getAuthToken, StorageService);

    const socket = yield call(getOrCreateSocket, SocketService, token);
    if (!socket.connected) {
      socket?.connect();
    }
    yield put(setSocket(socket));

    channel = yield call(createSocketChannel, socket);

    while (channel) {
      // FIXME handle unauthorized behavior
      const action = yield take(channel);
      yield put(action);
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      channel?.close();
    }
  }
}

function* startSocket() {
  socketTask = yield fork(watchSocketChannel);
}

function* stopSocket() {
  const { SocketService } = yield getContext(CONTEXT.SERVICES);
  if (socketTask) {
    yield cancel(socketTask);
    SocketService.disconnect();
    yield put(setSocket(null));
  }
}

export default function* watchSocket() {
  yield takeEvery(startSocketActionType, startSocket);
  yield takeEvery(stopSocketActionType, stopSocket);
}
